
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.2 4.632V2.316H8.8v2.316h4.4zm-11 2.315v12.737h17.6V6.947H2.2zm17.6-2.315c1.221 0 2.2 1.03 2.2 2.315v12.737C22 20.97 21.021 22 19.8 22H2.2C.979 22 0 20.97 0 19.684L.011 6.947c0-1.285.968-2.315 2.189-2.315h4.4V2.316C6.6 1.03 7.579 0 8.8 0h4.4c1.221 0 2.2 1.03 2.2 2.316v2.316h4.4z"}})])
          )
        }
      }
    